import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    page: 1,
    search: '',
  },
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
  },
};

const change = (store, data) => {
  store.setState((state) => {
    state.developer.stamping.retenciones.data = {
      ...state.developer.stamping.retenciones.data,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    state.developer.stamping.retenciones.busy = true;
  });

  try {
    params = {
      ...params,
      limit: params.limit || store.state.developer.stamping.retenciones.pagination.limit,
    };

    const response = await Http.get(`/app/audits/timbrado/retenciones`, { params });

    store.setState((state) => {
      state.developer.stamping.retenciones = {
        ...state.developer.stamping.retenciones,
        busy: false,
        data: response.data,
        pagination: {
          ...state.developer.stamping.retenciones.pagination,
          ...response.meta.pagination,
          limit: params.limit || state.developer.stamping.retenciones.pagination.limit,
        },
        filters: {
          ...state.developer.stamping.retenciones.filters,
          ...params,
          to: params.to,
          from: params.from,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.developer.stamping.retenciones = {
        ...state.developer.stamping.retenciones,
        busy: false,
        error: error.data || error,
      };
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.developer.stamping.retenciones = { ...initialState };
  });
};

export const TimbradoRetencionListStore = {
  state: () => initialState,
  actions: {
    change,
    paginate,
    reset,
  },
};

export default TimbradoRetencionListStore;
